import React from 'react';
import './App.css';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import Portfolio from './components/Portfolio';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Copyright from './components/Copyright';
import Skills from './components/Skills';
import Projects from './components/Projects';



const App = () => {
  return(
    <div>
    <Navbar/>
    <HeroSection/>
    <About/>
    <Skills/>
    <Projects/>
    <Contact/>
    <Footer/>
    <Copyright/>
    </div>
  );
}

export default App;